WL.registerComponent('packaging-controller', {
    paper1: {type: WL.Type.Material}
}, {
    
    start: function() {
        this.collision = this.object.getComponent('collision');
    },
    update: function(dt) {
        let overlaps = this.collision.queryOverlaps();
        
        for (let i = 0; i < overlaps.length; ++i) {
            let other = overlaps[i];
            other.object.getComponent('mesh').material = this.paper1;
        }
    },
});
